var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSetting = function SvgSetting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.55 3.119a2.02 2.02 0 0 1 1.382 1.917v.055c0 1.099.878 1.997 1.977 2.02l.118.003a2.02 2.02 0 0 1 1.764 1.116v0a2.02 2.02 0 0 1-.38 2.333l-.038.039a2.02 2.02 0 0 0-.03 2.826l.08.086a2.02 2.02 0 0 1 .459 2.036v0a2.02 2.02 0 0 1-1.918 1.382h-.055a2.02 2.02 0 0 0-2.02 1.977l-.003.118a2.02 2.02 0 0 1-1.116 1.763v0a2.02 2.02 0 0 1-2.333-.379l-.038-.038a2.02 2.02 0 0 0-2.827-.031l-.085.082a2.02 2.02 0 0 1-2.037.457v0a2.02 2.02 0 0 1-1.381-1.917v-.055a2.02 2.02 0 0 0-1.977-2.02l-.119-.003A2.02 2.02 0 0 1 3.21 15.77v0a2.02 2.02 0 0 1 .379-2.333l.038-.039a2.02 2.02 0 0 0 .031-2.826l-.081-.086a2.02 2.02 0 0 1-.458-2.036v0a2.02 2.02 0 0 1 1.917-1.382h.055a2.02 2.02 0 0 0 2.02-1.977l.003-.118A2.02 2.02 0 0 1 8.231 3.21v0a2.02 2.02 0 0 1 2.332.378l.039.04a2.02 2.02 0 0 0 2.827.03l.085-.082a2.02 2.02 0 0 1 2.037-.457",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2.501
  }))));
};
export { SvgSetting as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMTdiZTA0M2MwOGVmNzVkODhlYjAzNzZjMmI1Yjk3NTEuc3ZnIjs=";